<template>
    <article>
        <p>
            <a href="https://github.com/coroot/coroot-pg-agent" target="_blank">Pg-agent</a>
            is a Prometheus exporter for Postgres focusing on query performance statistics.
        </p>

        <h2>Features</h2>

        <h3>Comprehensive query metrics</h3>

        <p>
            The agent aggregates data from <var>pg_stat_statements</var> and <var>pg_stat_activity</var> to provide accurate
            metrics about queries, whether they are completed or still running.
        </p>
        <v-img eager max-width="80%" class="ma-auto mb-6" src="/static/img/blog/pg_stat_statements_visibility.svg" />
        <v-img eager max-width="80%" class="ma-auto mb-6" src="/static/img/blog/pg_stat_activity_visibility.svg" />

        <p>
            Learn more about query metrics in the blog post
            <a href="/blog/pg-missing-metrics">Missing metrics required to gain visibility into Postgres performance</a>
        </p>

        <h3>Locks monitoring</h3>

        <p>
            It is not enough to gather the number of active locks from <var>pg_locks</var>.
            What engineers really want to know is which query is blocking other queries.
            The <MetricLink name="pg_lock_awaiting_queries" exporter="pg-agent" /> metric can provide the answer to that.
        </p>


        <h3>Query normalization and obfuscation</h3>
        <p>
            In addition to query normalization, which Postgres does, the agent obfuscates all queries so that no sensitive data gets into the metrics labels.
        </p>

        <h2>License</h2>

            <p>
                Coroot-pg-agent is licensed under the <a href="https://github.com/coroot/coroot-pg-agent/blob/main/LICENSE" target="_blank">Apache License, Version 2.0</a>.
            </p>
    </article>
</template>

<script>

import MetricLink from "@/components/MetricLink";

export default {
    components: {MetricLink}

}
</script>

<style scoped>
</style>
